import { Disclosure } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/outline"
import React, { useState } from "react"
import { classNames } from "../graphichs/misc"

// const [hide, setHide] = useState<boolean>(true)
// const hideShow = () => {
//   let temp = hide
//   setHide(!temp)
// }

const HeaderHideShowChild = ({ props, children }) => {
  const text = props

  return (
    // <div className="mt-2 sm:mt-4">
    //   <h4 className="text-md text-meny-700 sm:text-xl" onClick={hideShow}>
    //     {text}
    //   </h4>
    //   {hide ? <></> : <div>{children}</div>}
    // </div>
    <Disclosure as="div" key={text} className="pt-6">
      {({ open }) => (
        <>
          <dt className="text-lg text-meny-700">
            <Disclosure.Button
              key={text}
              className="text-left w-full flex justify-between items-start text-gray-400"
            >
              <span className="flex items-center text-meny-700">
                {text}
                <ChevronDownIcon
                  className={classNames(
                    open ? "-rotate-180" : "rotate-0",
                    "h-6 w-6 transform ml-2"
                  )}
                  aria-hidden="true"
                />
              </span>
              <span className="ml-6 h-7 flex items-center"></span>
            </Disclosure.Button>
          </dt>
          <Disclosure.Panel as="dd" className="mt-0">
            {children}
          </Disclosure.Panel>{" "}
        </>
      )}
    </Disclosure>
  )
}

export default HeaderHideShowChild
